import React from 'react';
import moment from 'moment';
import {formatNumber, safeInnerHtmlText} from "../lib/utils";
import {FormField} from "../lib/forms";
import {forms} from "../lib/forms";

moment.locale('pt-br');

interface FieldViewProps {
  value: any;
  def?: FormField;
  label?: string;
  className?: string;
  type?: 'string' | 'number' | 'boolean' | 'date' | 'datetime' | 'telefone' | 'email' | 'cep' | 'checkbox' | 'text' | 'currency';
  format?: string;
  currency?: string;
}

const FieldView: React.FC<FieldViewProps> = (props) => {
  let type;
  let label;
  let value;
  let currency;

  if (props.def) {
    type = props.def.type;
    label = props.def.label;
  } else {
    type = props.type || 'string';
    label = props.label;
  }

  if (type === 'date') {
    const format = props.format || 'DD/MM/YYYY';
    value = props.value ? moment(props.value.toDate()).format(format) : '';
  } else if (type === 'datetime') {
    const format = props.format || 'DD/MM/YYYY HH:mm:ss';
    value = props.value ? moment(props.value.toDate()).format(format) : '';
  } else if (type === 'checkbox') {
    if (props.value) {
      if (typeof props.value === 'string')
        value = props.value;
      else
        value = props.value ? props.value.join(', ') : '';
    }
  } else if (type === 'boolean') {
    value = props.value ? 'Sim' : 'Não';
  } else if (type === 'currency') {
    if (props.value) {
      currency = props.currency || 'R$';
      value = `${currency} ${formatNumber(props.value)}`;
    } else
      value = '';
  } else if (type === 'cnpj') {
    value = props.value ? forms.utils.format.cnpj(props.value) : '';
  } else {
    value = props.value;
  }

  return (
    <div className="mb-4">
      <div className="text-gray-700 text-xs">{label}</div>
      {
        type === "text" &&
          <div
            className={props.className}
            dangerouslySetInnerHTML={safeInnerHtmlText(value)}
          />
      }
      {
        type !== "text" &&
          <div className={props.className}>
            {value}
          </div>
      }
    </div>
  )
};

export default FieldView;
